import React from "react";

import { getFormComponent } from "../../types/flyer-detail-page-form-config/flyer-detail-page-form-config.functions";
import { FlyerDetailPageFormProps } from "./flyer-detail-page-form.props";

export const FlyerDetailPageForm = (props: FlyerDetailPageFormProps) => {
  const FormComponent = getFormComponent(props.type);

  if (!FormComponent) {
    console.error(`No form component found for ${props.type}`);
    return null;
  }

  return <FormComponent {...props} />;
};
